export const themeData: ThemeData = {
    "description": "TYPE: CUSTOM\nMaterial Theme Builder export 2025-06-06 11:32:49",
    "seed": "#63A002",
    "coreColors": {
        "primary": "#63A002"
    },
    "extendedColors": [],
    "schemes": {
        "light": {
            "primary": "#4C662B",
            "surfaceTint": "#4C662B",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#CDEDA3",
            "onPrimaryContainer": "#354E16",
            "secondary": "#586249",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#DCE7C8",
            "onSecondaryContainer": "#404A33",
            "tertiary": "#386663",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#BCECE7",
            "onTertiaryContainer": "#1F4E4B",
            "error": "#BA1A1A",
            "onError": "#FFFFFF",
            "errorContainer": "#FFDAD6",
            "onErrorContainer": "#93000A",
            "background": "#F9FAEF",
            "onBackground": "#1A1C16",
            "surface": "#F9FAEF",
            "onSurface": "#1A1C16",
            "surfaceVariant": "#E1E4D5",
            "onSurfaceVariant": "#44483D",
            "outline": "#75796C",
            "outlineVariant": "#C5C8BA",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#2F312A",
            "inverseOnSurface": "#F1F2E6",
            "inversePrimary": "#B1D18A",
            "primaryFixed": "#CDEDA3",
            "onPrimaryFixed": "#102000",
            "primaryFixedDim": "#B1D18A",
            "onPrimaryFixedVariant": "#354E16",
            "secondaryFixed": "#DCE7C8",
            "onSecondaryFixed": "#151E0B",
            "secondaryFixedDim": "#BFCBAD",
            "onSecondaryFixedVariant": "#404A33",
            "tertiaryFixed": "#BCECE7",
            "onTertiaryFixed": "#00201E",
            "tertiaryFixedDim": "#A0D0CB",
            "onTertiaryFixedVariant": "#1F4E4B",
            "surfaceDim": "#DADBD0",
            "surfaceBright": "#F9FAEF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F3F4E9",
            "surfaceContainer": "#EEEFE3",
            "surfaceContainerHigh": "#E8E9DE",
            "surfaceContainerHighest": "#E2E3D8"
        },
        "light-medium-contrast": {
            "primary": "#253D05",
            "surfaceTint": "#4C662B",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#5A7539",
            "onPrimaryContainer": "#FFFFFF",
            "secondary": "#303924",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#667157",
            "onSecondaryContainer": "#FFFFFF",
            "tertiary": "#083D3A",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#477572",
            "onTertiaryContainer": "#FFFFFF",
            "error": "#740006",
            "onError": "#FFFFFF",
            "errorContainer": "#CF2C27",
            "onErrorContainer": "#FFFFFF",
            "background": "#F9FAEF",
            "onBackground": "#1A1C16",
            "surface": "#F9FAEF",
            "onSurface": "#0F120C",
            "surfaceVariant": "#E1E4D5",
            "onSurfaceVariant": "#34382D",
            "outline": "#505449",
            "outlineVariant": "#6B6F62",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#2F312A",
            "inverseOnSurface": "#F1F2E6",
            "inversePrimary": "#B1D18A",
            "primaryFixed": "#5A7539",
            "onPrimaryFixed": "#FFFFFF",
            "primaryFixedDim": "#425C23",
            "onPrimaryFixedVariant": "#FFFFFF",
            "secondaryFixed": "#667157",
            "onSecondaryFixed": "#FFFFFF",
            "secondaryFixedDim": "#4E5840",
            "onSecondaryFixedVariant": "#FFFFFF",
            "tertiaryFixed": "#477572",
            "onTertiaryFixed": "#FFFFFF",
            "tertiaryFixedDim": "#2E5C59",
            "onTertiaryFixedVariant": "#FFFFFF",
            "surfaceDim": "#C6C7BD",
            "surfaceBright": "#F9FAEF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F3F4E9",
            "surfaceContainer": "#E8E9DE",
            "surfaceContainerHigh": "#DCDED3",
            "surfaceContainerHighest": "#D1D3C8"
        },
        "light-high-contrast": {
            "primary": "#1C3200",
            "surfaceTint": "#4C662B",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#375018",
            "onPrimaryContainer": "#FFFFFF",
            "secondary": "#262F1A",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#434C35",
            "onSecondaryContainer": "#FFFFFF",
            "tertiary": "#003230",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#21504E",
            "onTertiaryContainer": "#FFFFFF",
            "error": "#600004",
            "onError": "#FFFFFF",
            "errorContainer": "#98000A",
            "onErrorContainer": "#FFFFFF",
            "background": "#F9FAEF",
            "onBackground": "#1A1C16",
            "surface": "#F9FAEF",
            "onSurface": "#000000",
            "surfaceVariant": "#E1E4D5",
            "onSurfaceVariant": "#000000",
            "outline": "#2A2D24",
            "outlineVariant": "#474B40",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#2F312A",
            "inverseOnSurface": "#FFFFFF",
            "inversePrimary": "#B1D18A",
            "primaryFixed": "#375018",
            "onPrimaryFixed": "#FFFFFF",
            "primaryFixedDim": "#213903",
            "onPrimaryFixedVariant": "#FFFFFF",
            "secondaryFixed": "#434C35",
            "onSecondaryFixed": "#FFFFFF",
            "secondaryFixedDim": "#2C3620",
            "onSecondaryFixedVariant": "#FFFFFF",
            "tertiaryFixed": "#21504E",
            "onTertiaryFixed": "#FFFFFF",
            "tertiaryFixedDim": "#033937",
            "onTertiaryFixedVariant": "#FFFFFF",
            "surfaceDim": "#B8BAAF",
            "surfaceBright": "#F9FAEF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F1F2E6",
            "surfaceContainer": "#E2E3D8",
            "surfaceContainerHigh": "#D4D5CA",
            "surfaceContainerHighest": "#C6C7BD"
        },
        "dark": {
            "primary": "#B1D18A",
            "surfaceTint": "#B1D18A",
            "onPrimary": "#1F3701",
            "primaryContainer": "#354E16",
            "onPrimaryContainer": "#CDEDA3",
            "secondary": "#BFCBAD",
            "onSecondary": "#2A331E",
            "secondaryContainer": "#404A33",
            "onSecondaryContainer": "#DCE7C8",
            "tertiary": "#A0D0CB",
            "onTertiary": "#003735",
            "tertiaryContainer": "#1F4E4B",
            "onTertiaryContainer": "#BCECE7",
            "error": "#FFB4AB",
            "onError": "#690005",
            "errorContainer": "#93000A",
            "onErrorContainer": "#FFDAD6",
            "background": "#12140E",
            "onBackground": "#E2E3D8",
            "surface": "#12140E",
            "onSurface": "#E2E3D8",
            "surfaceVariant": "#44483D",
            "onSurfaceVariant": "#C5C8BA",
            "outline": "#8F9285",
            "outlineVariant": "#44483D",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E2E3D8",
            "inverseOnSurface": "#2F312A",
            "inversePrimary": "#4C662B",
            "primaryFixed": "#CDEDA3",
            "onPrimaryFixed": "#102000",
            "primaryFixedDim": "#B1D18A",
            "onPrimaryFixedVariant": "#354E16",
            "secondaryFixed": "#DCE7C8",
            "onSecondaryFixed": "#151E0B",
            "secondaryFixedDim": "#BFCBAD",
            "onSecondaryFixedVariant": "#404A33",
            "tertiaryFixed": "#BCECE7",
            "onTertiaryFixed": "#00201E",
            "tertiaryFixedDim": "#A0D0CB",
            "onTertiaryFixedVariant": "#1F4E4B",
            "surfaceDim": "#12140E",
            "surfaceBright": "#383A32",
            "surfaceContainerLowest": "#0C0F09",
            "surfaceContainerLow": "#1A1C16",
            "surfaceContainer": "#1E201A",
            "surfaceContainerHigh": "#282B24",
            "surfaceContainerHighest": "#33362E"
        },
        "dark-medium-contrast": {
            "primary": "#C7E79E",
            "surfaceTint": "#B1D18A",
            "onPrimary": "#172B00",
            "primaryContainer": "#7D9A59",
            "onPrimaryContainer": "#000000",
            "secondary": "#D5E1C2",
            "onSecondary": "#1F2814",
            "secondaryContainer": "#8A9579",
            "onSecondaryContainer": "#000000",
            "tertiary": "#B5E6E1",
            "onTertiary": "#002B29",
            "tertiaryContainer": "#6B9995",
            "onTertiaryContainer": "#000000",
            "error": "#FFD2CC",
            "onError": "#540003",
            "errorContainer": "#FF5449",
            "onErrorContainer": "#000000",
            "background": "#12140E",
            "onBackground": "#E2E3D8",
            "surface": "#12140E",
            "onSurface": "#FFFFFF",
            "surfaceVariant": "#44483D",
            "onSurfaceVariant": "#DBDECF",
            "outline": "#B0B3A6",
            "outlineVariant": "#8E9285",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E2E3D8",
            "inverseOnSurface": "#282B24",
            "inversePrimary": "#364F17",
            "primaryFixed": "#CDEDA3",
            "onPrimaryFixed": "#081400",
            "primaryFixedDim": "#B1D18A",
            "onPrimaryFixedVariant": "#253D05",
            "secondaryFixed": "#DCE7C8",
            "onSecondaryFixed": "#0B1403",
            "secondaryFixedDim": "#BFCBAD",
            "onSecondaryFixedVariant": "#303924",
            "tertiaryFixed": "#BCECE7",
            "onTertiaryFixed": "#001413",
            "tertiaryFixedDim": "#A0D0CB",
            "onTertiaryFixedVariant": "#083D3A",
            "surfaceDim": "#12140E",
            "surfaceBright": "#43453D",
            "surfaceContainerLowest": "#060804",
            "surfaceContainerLow": "#1C1E18",
            "surfaceContainer": "#262922",
            "surfaceContainerHigh": "#31342C",
            "surfaceContainerHighest": "#3C3F37"
        },
        "dark-high-contrast": {
            "primary": "#DAFBB0",
            "surfaceTint": "#B1D18A",
            "onPrimary": "#000000",
            "primaryContainer": "#ADCD86",
            "onPrimaryContainer": "#050E00",
            "secondary": "#E9F4D5",
            "onSecondary": "#000000",
            "secondaryContainer": "#BCC7A9",
            "onSecondaryContainer": "#060D01",
            "tertiary": "#C9F9F5",
            "onTertiary": "#000000",
            "tertiaryContainer": "#9CCCC7",
            "onTertiaryContainer": "#000E0D",
            "error": "#FFECE9",
            "onError": "#000000",
            "errorContainer": "#FFAEA4",
            "onErrorContainer": "#220001",
            "background": "#12140E",
            "onBackground": "#E2E3D8",
            "surface": "#12140E",
            "onSurface": "#FFFFFF",
            "surfaceVariant": "#44483D",
            "onSurfaceVariant": "#FFFFFF",
            "outline": "#EEF2E2",
            "outlineVariant": "#C1C4B6",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E2E3D8",
            "inverseOnSurface": "#000000",
            "inversePrimary": "#364F17",
            "primaryFixed": "#CDEDA3",
            "onPrimaryFixed": "#000000",
            "primaryFixedDim": "#B1D18A",
            "onPrimaryFixedVariant": "#081400",
            "secondaryFixed": "#DCE7C8",
            "onSecondaryFixed": "#000000",
            "secondaryFixedDim": "#BFCBAD",
            "onSecondaryFixedVariant": "#0B1403",
            "tertiaryFixed": "#BCECE7",
            "onTertiaryFixed": "#000000",
            "tertiaryFixedDim": "#A0D0CB",
            "onTertiaryFixedVariant": "#001413",
            "surfaceDim": "#12140E",
            "surfaceBright": "#4F5149",
            "surfaceContainerLowest": "#000000",
            "surfaceContainerLow": "#1E201A",
            "surfaceContainer": "#2F312A",
            "surfaceContainerHigh": "#3A3C35",
            "surfaceContainerHighest": "#454840"
        }
    },
    "palettes": {
        "primary": {
            "0": "#000000",
            "5": "#081400",
            "10": "#102000",
            "15": "#172B00",
            "20": "#1F3700",
            "25": "#264300",
            "30": "#2F4F00",
            "35": "#375C00",
            "40": "#3F6900",
            "50": "#518500",
            "60": "#64A104",
            "70": "#7DBD2A",
            "80": "#97D945",
            "90": "#B2F65F",
            "95": "#D2FF9B",
            "98": "#F0FFD7",
            "99": "#F9FFE9",
            "100": "#FFFFFF"
        },
        "secondary": {
            "0": "#000000",
            "5": "#081400",
            "10": "#121F04",
            "15": "#1C2A0B",
            "20": "#263515",
            "25": "#31401F",
            "30": "#3C4C2A",
            "35": "#485734",
            "40": "#54643F",
            "50": "#6C7D56",
            "60": "#85976E",
            "70": "#A0B187",
            "80": "#BBCDA1",
            "90": "#D7E9BB",
            "95": "#E5F7C9",
            "98": "#F0FFD7",
            "99": "#F9FFE9",
            "100": "#FFFFFF"
        },
        "tertiary": {
            "0": "#000000",
            "5": "#001413",
            "10": "#00201E",
            "15": "#002B29",
            "20": "#003735",
            "25": "#004340",
            "30": "#00504C",
            "35": "#005D59",
            "40": "#046A66",
            "50": "#30837F",
            "60": "#4D9D98",
            "70": "#69B8B3",
            "80": "#85D4CF",
            "90": "#A1F1EB",
            "95": "#B0FFF9",
            "98": "#E3FFFC",
            "99": "#F2FFFD",
            "100": "#FFFFFF"
        },
        "neutral": {
            "0": "#000000",
            "5": "#10110D",
            "10": "#1B1C18",
            "15": "#252622",
            "20": "#30312C",
            "25": "#3B3C37",
            "30": "#464742",
            "35": "#52534D",
            "40": "#5E5F59",
            "50": "#777771",
            "60": "#91918B",
            "70": "#ABACA5",
            "80": "#C7C7C0",
            "90": "#E3E3DB",
            "95": "#F2F1E9",
            "98": "#FAFAF2",
            "99": "#FDFCF5",
            "100": "#FFFFFF"
        },
        "neutral-variant": {
            "0": "#000000",
            "5": "#0E120A",
            "10": "#191D14",
            "15": "#23271D",
            "20": "#2E3228",
            "25": "#393D32",
            "30": "#44483D",
            "35": "#505449",
            "40": "#5C6054",
            "50": "#75796C",
            "60": "#8F9285",
            "70": "#A9AD9F",
            "80": "#C5C8BA",
            "90": "#E1E4D5",
            "95": "#EFF2E3",
            "98": "#F8FBEB",
            "99": "#FBFEEE",
            "100": "#FFFFFF"
        }
    }
}